export default __webpack_public_path__ + "assets/img/sidebar-ex4.png";